import client from '@/shared/apis/client'
import { FormatInsertRule } from '@/features/internal/format-insert-rules/types/formatInsertRule'

const BASE_URL = '/api/format-insert-rules'

export class FormatInsertRuleAPI {
  async getRules(): Promise<FormatInsertRule[]> {
    const response = await client.get<{
      count: number
      results: FormatInsertRule[]
    }>(`${BASE_URL}/`)
    return response.data.results
  }

  async getRule(id: string): Promise<FormatInsertRule> {
    const response = await client.get<FormatInsertRule>(`${BASE_URL}/${id}/`)
    return response.data
  }

  async createRule(
    rule: Omit<FormatInsertRule, 'id' | 'created_at' | 'updated_at'>
  ): Promise<FormatInsertRule> {
    const response = await client.post<FormatInsertRule>(`${BASE_URL}/`, rule)
    return response.data
  }

  async updateRule(
    id: string,
    rule: Partial<FormatInsertRule>
  ): Promise<FormatInsertRule> {
    const response = await client.patch<FormatInsertRule>(
      `${BASE_URL}/${id}/`,
      rule
    )
    return response.data
  }

  async toggleActive(
    id: string
  ): Promise<{ id: string; is_active: boolean; message: string }> {
    const response = await client.post<{
      id: string
      is_active: boolean
      message: string
    }>(`${BASE_URL}/${id}/toggle_active/`)
    return response.data
  }

  async deleteRule(id: string): Promise<void> {
    await client.delete(`${BASE_URL}/${id}/`)
  }
}

export const formatInsertRuleAPI = new FormatInsertRuleAPI()
